import React, { useState, useEffect, useCallback } from "react";
import {
  TextField,
  ThemeProvider,
  createTheme,
  Autocomplete,
  Button,
  Alert,
} from "@mui/material";
import { common_axios } from "../../../../App";
import { Form, Formik, useFormik, Field, FieldArray } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../../components/Loader";
import Backdrop from "@mui/material/Backdrop";
import { InputAdornment, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import SettingsBackupRestoreRoundedIcon from "@mui/icons-material/SettingsBackupRestoreRounded";
import "antd/dist/antd.css";
import { Transfer } from "antd";
import { useDispatch } from "react-redux";
import { setRelodState } from "../../../../redux/actions/reloadAction";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import TransferListTest from "./TransferListTest";
import Swal from "sweetalert2";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
const AddBulkGroup = ({resetValue}) => {
  const customId1 = "custom-id-yess";
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });
  const dispatch = useDispatch();
const [resetState, setResetState] = useState(false);
  const [description, setdescription] = useState("");
  const [transferListData, setTransferListData] = useState([]);
  const [open, setOpen] = useState();
  const [changeState, setchangeState] = useState(false);
  const [data, setData] = useState([]);
  const [Search, setSearch] = useState(undefined);
  const [Alphabet, setAlphabet] = useState([]);
  const [AlphabetName, setAlphabetName] = useState("A");
  // console.log(AlphabetName, "8iko");
  const [data1, setData1] = useState([]);
  const [hideSkeleton, setHideSkeleton] = useState();
  const [RelodPhoneBookList, setRelodPhoneBookList] = useState(true);
  // .............................transfer list...................................//
  const [mockData, setMockdata] = useState([]);
  const [targetKeys, setTargetKeys] = useState([]);
  const [targetId, setTargetId] = useState([]);
  const [SelectedContactName, setSelectedContactName] = useState([]);
  // console.log("uyy55", targetId);
  useEffect(() => {
    // getMock();
    const targetKeys = [];
    const mockData = [];
    const targetId = [];
    for (let i = 0; i < data1.length; i++) {
      const data = {
        // key: i.toString(),
        key: `${data1[i].id}`,
        id: `${data1[i].id}`,
        // title: `content${i + 1}`,
        title: `${data1[i].phonebookName}`,
        // description: `description of content${i + 1}`,
        // chosen: Math.random() * 2 > 1,
        chosen: "",
      };
      if (data.id) {
        targetId.push(data.id);
        targetKeys.push(data.key);
        // SelectedContactName.push(data.title)
      }
      mockData.push(data);
    }
    setMockdata(mockData);
    // setSelectedContactName(SelectedContactName)

    // setTargetKeys(targetKeys);
    // setTargetId(targetId);
  }, [data1]);
  let x = [];
  let y = [];
  const handleChange9 = (targetKeys) => {
    // console.log("target--", targetKeys);
    setTargetKeys(targetKeys);
    for (let i = 0; i < mockData.length; i++) {
      for (let j = 0; j < targetKeys.length; j++) {
        if (targetKeys[j] == mockData[i].id) {
          // x.push(mockData[i].id);

          x.push(
            // { id: mockData[i].id },
            { id: mockData[i].id }
          );
          y.push({
            name: mockData[i].title,
          });
        }
      }
    }
    setTargetId(x);
    setSelectedContactName(y);
  };

  function handleChange1(event) {
    setSearch(event.target.value);
  }
  function handleChange2(event) {
    // alert("899")
    setSearch(event.target.value);
  }
  // .....................................Formik............................................//
  const initialValues = {
    bulkGroupPhonebookName: "",
    // bulkGroupDescription: "",
  };
  const validationSchema = yup.object({
    bulkGroupPhonebookName: yup
      .string()
      .min(3, "Please enter atleast 3 characters in phonebookName")
      .max(90, "No more longer to 90 charcaters")
      .required("Required"),
  });

  const formik = useFormik({
    initialValues: initialValues,

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validationSchema: validationSchema,
    onSubmit: (values) => {
      PhoneBookPost(values);
    },
  });
  // .............................A B C D Get API.......................//
  // console.log("abcc", Alphabet);
  async function AlphabetGet(values) {
    try {
      // setHideSkeleton(true);
      const res = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/phone-book/get/alphabet?alphabet=${AlphabetName}`
      );
      if (res.data.statusdescription.statusCode == 200) {
        setAlphabet(res.data.alphabets);
      } else {
        toast.error(res.data.statusdescription.statusDescription, {
          toastId: customId1,
        });
      }
    } catch (error) {
      toast.error("Please Check Your Network", {
        toastId: customId1,
      });
    }
  }
  //.......................Sidebar Alphabet get........................//
  async function SidebarAlphabetGet(values) {
    try {
      setOpen(true);
      setHideSkeleton(true);
      const res = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/phone-book/list/by/phone-book-name?&phoneBookName=${AlphabetName}`
      );
      if (res.data.statusdescription.statusCode == 200) {
        setData1(res.data.listOfPlaysmsPhonebook);
        setOpen(false);
        setHideSkeleton(false);
      } else {
        setOpen(false);

        toast.error(res.data.statusdescription.statusDescription, {
          toastId: customId1,
        });
      }
    } catch (error) {
      toast.error("Please Check Your Network", {
        toastId: customId1,
      });
      setOpen(false);
    }
  }
  // ............................Transfer list Get data.......................//
  async function BulkGroupGet(values) {
    try {
      setHideSkeleton(true);
      const res = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/bulk-group/get/phone-book/list`
      );
      if (res.data.statusdescription.statusCode == 200) {
        setHideSkeleton(false);
        setData1(res.data.listOfPlaysmsPhonebook);
      } else {
        setHideSkeleton(false);
        toast.error(res.data.statusdescription.statusDescription, {
          toastId: customId1,
        });
      }
    } catch (error) {
      setHideSkeleton(false);

      toast.error("Please Check Your Network", {
        toastId: customId1,
      });
    }
  }
  // ............................Post Api...............................//
  async function PhoneBookPost(values) {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/bulk-group/phone-book/create`,
        {
          bulkGroupPhonebookName: values.bulkGroupPhonebookName,
          bulkGroupDescription: description,
          phoneBookReq: transferListData,
          createdBy:localStorage.getItem("Username")

        }
      );
      if (res.data.statusdescription.statusCode == 200) {
        setOpen(false);
        setRelodPhoneBookList(!RelodPhoneBookList);
        dispatch(setRelodState(RelodPhoneBookList));
        setTargetId([]);
        setTargetKeys([]);
        setResetState(!resetState);

        formik.handleReset();
        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text:"BulkGroup Added successfully!!",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        setchangeState(!changeState);
        localStorage.setItem(
          "contactName",
          JSON.stringify(SelectedContactName)
        );
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
           title: "Oops...",
          text:res.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      // toast.error("Please Check Your Network");
      Swal.fire({
        icon: "error",
         title: "Oops...",
        text:"Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  useEffect(() => {
    if (Search != undefined) {
      // SearchName();
    }
  }, [Search]);
  const resetbutton = () => {
    setdescription("");
  };
  const handleData = useCallback(
    (data) => {
      setTransferListData(data);
    },
    [transferListData]
  );

  useEffect(() => {
    formik.handleReset();
    setdescription("");
  }, [resetValue]);
  return (
    <>
      <main className="main-content position-relative border-radius-lg ">
        <div>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={open}
          >
            <Loader />
          </Backdrop>
        </div>
        <div className="card-body">
          <div className="card shadow-none border bg_blue mt-4">
            <span className="badge rounded-pill bg-primary mt-n3 ms-5">
              {/* Add Number */}
              Add Group
            </span>
            <div className="card-body text-lg-start text-center">
              <section class="right_panel px-0">
                <div class="container-fluid_1">
                  <div class="tab-content" id="pills-tabContent">
                    <ThemeProvider theme={theme}>
                      <div
                        class="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        <form
                          onSubmit={formik.handleSubmit}
                          role="form"
                          className="text-start"
                        >
                          <div class="">
                            <div class="row justify-content-cente">
                              <div class="col-md-4">
                                <TextField
                                  className= "w-100"
                                  style={{
                                    borderRadius: "4px",
                                  }}
                                  type="text"
                                  label="Add New BulkGroup"
                                  name="bulkGroupPhonebookName"
                                  variant="outlined"
                                  size="small"
                                  required
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Tooltip
                                          title="Group Name"
                                          placement="top"
                                          arrow
                                          sx={{ color: "#85CBF2" }}
                                        >
                                          <InfoIcon />
                                        </Tooltip>
                                      </InputAdornment>
                                    ),
                                  }}
                                  onChange={formik.handleChange}
                                  value={formik.values.bulkGroupPhonebookName}
                                  error={
                                    formik.touched.bulkGroupPhonebookName &&
                                    Boolean(
                                      formik.errors.bulkGroupPhonebookName
                                    )
                                  }
                                  helperText={
                                    formik.touched.bulkGroupPhonebookName &&
                                    formik.errors.bulkGroupPhonebookName
                                  }
                                />
                              </div>
                              <div class="col-md-4">
                                {/* <TextField
                                  className=" w-100"
                                  style={{
                                    borderRadius: "4px",
                                  }}
                                  type="text"
                                  label="Group Description"
                                  name="bulkGroupDescription"
                                  variant="outlined"
                                  size="small"
                                  // required
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Tooltip
                                          title="Group Description"
                                          placement="top"
                                          arrow
                                          sx={{ color: "#85CBF2" }}
                                        >
                                          <InfoIcon />
                                        </Tooltip>
                                      </InputAdornment>
                                    ),
                                  }}
                                  value={description}
                                  onChange={(event) => {
                                    setdescription(event.target.value);
                                  }}
                                /> */}
                                <TextareaAutosize
                                  //  disabled
                                  className={
                                    formik.errors.message
                                      ? "border-color-red w-100"
                                      : "w-100  textarea_8"
                                  }
                                  textarea_8
                                  aria-label="empty textarea"
                                  placeholder="  Enter Description"
                                  name="description"
                                  style={{
                                    width: " 700px",
                                    minHeight: "100%",
                                    height: "100%",
                                    borderColor: " #48a8dd",
                                  }}
                                  maxlength="100"
                                  // required
                                  value={description}
                                  onChange={(event) => {
                                    setdescription(event.target.value);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="mt-5" id="user_contact_list">
                              {/* <div class="d-flex">
                                <TextField
                                  className="w-50 mx-auto"
                                  style={{
                                    borderRadius: "4px",
                                  }}
                                  type="text"
                                  label="Search"
                                  name="search"
                                  variant="outlined"
                                  size="small"
                                  onChange={handleChange1}
                                />
                              </div> */}
                              <div
                                className="d-flex justify-content-cente" id="changeWidth"
                                style={{
                                  display: "flex",
                                  marginTop: "26px",
                                  width: "100%",
                                }}
                              >
                                {/* <div
                                  className="alphabet-list align-self-star my-auto"
                                  style={{
                                    borderRadius: "0",
                                    padding: "5px 0",
                                    marginRight: "0",
                                    border: "1px solid #d9d9d9",
                                    borderRight: "none",
                                  }}
                                >
                                  {Alphabet?.map((arg) => {
                                    return (
                                      <>
                                        <div
                                          className=""
                                          // onClick={handleChange2}
                                          onClick={() => {
                                            setAlphabetName(arg.alphabet);
                                          }}
                                          onMouseEnter={() => {
                                            // setSearch(arg.name);
                                          }}
                                          value={arg.alphabet}
                                        >
                                          {arg.alphabet}
                                        </div>
                                      </>
                                    );
                                  })}
                                </div> */}
                                {hideSkeleton == true ? (
                                  <>
                                    <Box sx={{ width: 150 }}></Box>
                                  </>
                                ) : (
                                  <>
                                    {/* <div>
                                      <div class="d-flex justify-content-between label_transfer">
                                        <label class="d-block">
                                          User Phonebook List
                                        </label>
                                        <label class="d-block">
                                          Add Phonebook In BulkGroup{" "}
                                        </label>
                                      </div>
                                      <Transfer
                                        dataSource={mockData}
                                        // showSearch
                                        listStyle={{
                                          width: 270,
                                          height: 509,
                                        }}
                                        operations={["Add", "Remove"]}
                                        targetKeys={targetKeys}
                                        onChange={handleChange9}
                                        render={(item) => `${item.title}`}
                                        pagination
                                      />
                                    </div> */}

                                    <TransferListTest
                                    bulkGroupPhonebookName={formik.values.bulkGroupPhonebookName}
                                    resetState={resetState}
                                      onData={handleData}
                                      width={350}
                                      height={300}
                                      pageType="AddPage"
                                    />
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="d-flex justify-content-between mt-3">

                          <button
                              onClick={() => {
                                formik.resetForm();
                                setResetState(!resetState);
                                setdescription("")
                              }}
                              type="button"
                              className="btn resetBtn_UP ms-2 w_btn btn_w8 m-0"
                              // onClick={Reset}
                            >
                              Reset
                              {/* <SettingsBackupRestoreRoundedIcon
                                style={{ fontSize: "17px" }}
                              /> */}
                            </button>

                            {/* <button
                              type="submit"
                              style={{ width: "60px", height: "40px" }}
                              disabled={transferListData?.length == 0}
                              className="ant-btn ant-btn-primary ant-btn-sm"
                            > */}
                             <button
                            type="submit"
                            disabled={transferListData?.length == 0}
                            class="btn green_UP text-capitalize d-block  m-0"
                          >
                              save
                              {/* <ArrowForwardIcon style={{ fontSize: "17px" }}/> */}

                            </button>
                           
                          </div>
                        </form>
                      </div>
                    </ThemeProvider>
                  </div>
                </div>
              </section>
            </div>
          </div>
          {/* ------------------------------------Table------------------------------- */}
        </div>
      </main>
    </>
  );
};
export default AddBulkGroup;
